import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "moment-timezone";
import Flatpickr from "react-flatpickr";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Loader from "../layout/Loader";
import Pagination from "../layout/Pagination";
import PermissionGate from "../layout/PermissionGate";

const AllMerchants = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState("");
  const [type, setType] = useState([]);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [merchant, setMerchant] = useState({});
  const [popup, setPopup] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const dateRangePickerRef = useRef(null);
  const token = localStorage.getItem("token");
  const limit = process.env.REACT_APP_PAGINATION_LIMIT;
  const fetchMerchants = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT
        }all-merchants?page=${page}&limit=${limit}&search=${search}&type=${type.join(
          ","
        )}&start=${start}&end=${end}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          if (page > 1) {
            if (res.data.data.length === 0) {
              setPage(page - 1);
            } else {
              setData(res.data.data);
              setCount(res.data.count);
              setIsLoading(false);
            }
          } else {
            setData(res.data.data);
            setCount(res.data.count);
            setIsLoading(false);
          }
        } else {
          setIsLoading(false);
        }
      })
      .catch(console.error);
  };
  const processMerchantType = (merchantType) => {
    if (type.includes(merchantType)) {
      const prevType = [...type];
      const updatedType = [];
      prevType.map((item) => {
        if (item !== merchantType) {
          updatedType.push(item);
        }
      });
      setType(updatedType);
    } else {
      const prevType = [...type];
      prevType.push(merchantType);
      setType(prevType);
    }
  };
  const reset = () => {
    setPage(1);
    setSearch("");
    setType([]);
    setStart("");
    setEnd("");
  };
  const openCalendar = () => {
    if (dateRangePickerRef.current) {
      dateRangePickerRef.current.flatpickr.open();
    }
  };
  const openPopup = (action, data) => {
    setMerchant(data);
    setPopup(action);
  };
  const changeStatus = () => {
    if (merchant.id !== undefined && merchant.status !== undefined) {
      const status = merchant.status === true ? false : true;
      axios
        .post(
          `${process.env.REACT_APP_API_ENDPOINT}change-merchant-status`,
          {
            id: merchant.id,
            status: status,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res.data.code === 1) {
            setPopup("");
            setMerchant({});
            fetchMerchants();
          }
        })
        .catch(console.error);
    }
  };
  const deleteMerchant = () => {
    if (merchant.id !== undefined) {
      axios
        .post(
          `${process.env.REACT_APP_API_ENDPOINT}delete-merchant`,
          {
            id: merchant.id,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res.data.code === 1) {
            setPopup("");
            setMerchant({});
            fetchMerchants();
          }
        })
        .catch(console.error);
    }
  };
  const toggleSelectMerchant = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };
  const toggleSelectAllMerchants = () => {
    if (selectedIds.length === data.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(data.map((merchant) => merchant._id));
    }
  };
  const openCreditCardTopupPopup = (status) => {
    setMerchant({ status });
    setPopup("credit-card-topup");
  };
  const updateCreditCardTopup = () => {
    if (selectedIds.length === 0 || merchant.status === undefined) {
      return;
    }
    axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT}update-merchant-credit-card-topup`,
        {
          ids: selectedIds,
          status: merchant.status,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          setPopup("");
          setMerchant({});
          setSelectedIds([]);
          fetchMerchants();
        }
      })
      .catch(console.error);
  };
  useEffect(() => {
    setSelectedIds([]);
  }, [data]);
  useEffect(() => {
    fetchMerchants();
  }, [page, search, type, start, end]);
  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column flex-root">
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                  {/*begin::Title*/}
                  <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                    Merchant List
                  </h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
                {/*begin::Actions*/}
                <PermissionGate
                  required={`view_merchant_list`}
                  fallback={<></>}
                >
                  <div className="d-flex align-items-center overflow-auto">
                    {/*begin::Button*/}
                    <button
                      onClick={() => {
                        processMerchantType("Regular");
                      }}
                      className={
                        type.includes("Regular")
                          ? "btn btn-color-light bg-primary me-3"
                          : "btn btn-color-primary bg-body me-3"
                      }
                    >
                      Regular
                    </button>
                    <br />
                    {/*end::Button*/}

                    {/*begin::Button*/}

                    <button
                      onClick={() => {
                        processMerchantType("Ecommerce");
                      }}
                      className={
                        type.includes("Ecommerce")
                          ? "btn btn-color-light bg-success me-3"
                          : "btn btn-color-success bg-body me-3"
                      }
                    >
                      Ecommerce
                    </button>
                    <br />
                    {/*end::Button*/}

                    {/*begin::Button*/}

                    <button
                      onClick={() => {
                        processMerchantType("API User");
                      }}
                      className={
                        type.includes("API User")
                          ? "btn btn-color-light bg-warning me-3 text-nowrap"
                          : "btn btn-color-warning bg-body me-3 text-nowrap"
                      }
                    >
                      API User
                    </button>
                    <br />
                    {/*end::Button*/}

                    {/*begin::Button*/}

                    <button
                      onClick={() => {
                        processMerchantType("Customer");
                      }}
                      className={
                        type.includes("Customer")
                          ? "btn btn-color-light bg-danger me-3"
                          : "btn btn-color-danger bg-body me-3"
                      }
                    >
                      Customer
                    </button>
                    <br />
                    {/*end::Button*/}

                    {/*begin::Daterange*/}
                    <div className="d-flex position-relative flex-shrink-0">
                      <Flatpickr
                        ref={dateRangePickerRef}
                        value={[new Date(start), new Date(end)]}
                        options={{ dateFormat: "d-m-Y", mode: "range" }}
                        onChange={([start, end]) => {
                          if (start !== undefined && end !== undefined) {
                            setStart(moment(start).format("YYYY-MM-DD"));
                            setEnd(moment(end).format("YYYY-MM-DD"));
                          }
                        }}
                        className="form-control form-control-lg"
                        placeholder="Pick date"
                      />
                      <i
                        onClick={openCalendar}
                        className="bi-duotone bi-calendar fs-5 position-absolute"
                        style={{ top: "28%", right: "5%", cursor: "pointer" }}
                      ></i>
                    </div>
                    {/*end::Daterange*/}

                    {/*begin::Button*/}

                    <button
                      onClick={reset}
                      className="btn btn-color-danger bg-body mx-3"
                    >
                      Reset
                    </button>
                    {/*end::Button*/}
                  </div>
                </PermissionGate>

                {/*end::Actions*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}

            {/*begin::Container*/}
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start  container-xxl "
            >
              {/*begin::Post*/}
              <div className="content flex-row-fluid" id="kt_content">
                {/*begin::Card*/}
                <PermissionGate required={`view_merchant_list`}>
                  <div className="card">
                    {/*begin::Card header*/}
                    <div className="card-header border-0 pt-6">
                      {/*begin::Search*/}
                      <div className="my-1 w-100">
                        <input
                          value={search}
                          onChange={(e) => {
                            setSearch(e.target.value);
                          }}
                          type="text"
                          data-kt-user-table-filter="search"
                          className="form-control w-100"
                          placeholder="Search Merchant"
                        />
                      </div>
                      {/*end::Search*/}
                      {/*begin::Bulk actions*/}
                      <PermissionGate
                        required={`manage_merchant_credit_card_topup`}
                        fallback={<></>}
                        show={false}
                      >
                        {selectedIds.length > 0 && (
                          <div className="d-flex align-items-center gap-3 mt-4">
                            <span className="fw-bold text-gray-700">
                              {selectedIds.length} Merchant
                              {selectedIds.length > 1 ? "s" : ""} Selected
                            </span>
                            <button
                              onClick={() => openCreditCardTopupPopup(true)}
                              className="btn btn-sm btn-success"
                            >
                              Enable Credit Card Topup
                            </button>
                            <button
                              onClick={() => openCreditCardTopupPopup(false)}
                              className="btn btn-sm btn-warning"
                            >
                              Disable Credit Card Topup
                            </button>
                          </div>
                        )}
                      </PermissionGate>
                      {/*end::Bulk actions*/}
                    </div>
                    {/*end::Card header*/}

                    {/*begin::Card body*/}
                    <div className="card-body py-4 text-center">
                      {/*begin::Table*/}
                      {data?.length === 0 ? (
                        <div className="text-center w-100">
                          <img
                            className="w-25 mx-auto py-20"
                            src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/misc/no-content.png`}
                            alt="no-content"
                          />
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table
                            className="table align-middle table-row-dashed fs-6 gy-5"
                            id="kt_table_users"
                          >
                            <thead>
                              <tr className="text-muted fw-bold fs-7 text-uppercase gs-0">
                                <PermissionGate
                                  required={`manage_merchant_credit_card_topup`}
                                  fallback={<></>}
                                  show={false}
                                >
                                  <th className="text-center min-w-50px">
                                    <div className="form-check form-check-sm form-check-custom form-check-solid">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={
                                          data.length > 0 &&
                                          selectedIds.length === data.length
                                        }
                                        onChange={toggleSelectAllMerchants}
                                      />
                                    </div>
                                  </th>
                                </PermissionGate>
                                <th className="text-center min-w-100px">
                                  Merchant Logo
                                </th>
                                <th className="text-center min-w-100px">
                                  Merchant Name
                                </th>
                                <th className="text-center min-w-100px">
                                  Type
                                </th>
                                <th className="text-center min-w-100px">
                                  Currency
                                </th>
                                <th className="text-center min-w-100px">
                                  Pricing Model
                                </th>
                                <th className="text-center min-w-100px">
                                  Memeber Since
                                </th>
                                <th className="text-center min-w-100px">
                                  Status
                                </th>
                                <PermissionGate
                                  required={`manage_merchant_credit_card_topup`}
                                  fallback={<></>}
                                  show={false}
                                >
                                  <th className="text-center min-w-100px">Credit Card Topup</th>
                                </PermissionGate>
                                <th className="text-center min-w-100px">
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody
                              className="text-gray-600 fw-semibold"
                              id="filterDataWrap"
                            >
                              {data &&
                                data.map((merchant, index) => {
                                  return (
                                    <tr className="text-center" key={index}>
                                      <PermissionGate
                                        required={`manage_merchant_credit_card_topup`}
                                        fallback={<></>}
                                        show={false}
                                      >
                                        <td>
                                          <div className="form-check form-check-sm form-check-custom form-check-solid">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              checked={selectedIds.includes(merchant._id)}
                                              onChange={() => {
                                                toggleSelectMerchant(merchant._id);
                                              }}
                                            />
                                          </div>
                                        </td>
                                      </PermissionGate>
                                      <td>
                                        {/*begin:: Avatar */}
                                        <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                          <Link
                                            to={`/merchants/merchant-details/${merchant._id}`}
                                          >
                                            <div className="symbol-label">
                                              <img
                                                src={
                                                  process.env
                                                    .REACT_APP_API_PUBLIC_URL +
                                                  merchant.merchantLogo
                                                }
                                                alt={merchant.merchantName}
                                                className="w-100"
                                              />
                                            </div>
                                          </Link>
                                        </div>
                                        {/*end::Avatar*/}
                                      </td>
                                      <td>
                                        {/*begin::User details*/}
                                        <div className="d-flex">
                                          <Link
                                            to={`/merchants/merchant-details/${merchant._id}`}
                                            className="text-gray-800 text-hover-primary"
                                          >
                                            {merchant.merchantName}
                                          </Link>
                                        </div>
                                        {/*begin::User details*/}
                                      </td>
                                      <td>{merchant.merchantType}</td>
                                      <td>
                                        <div className="badge bg-warning text-white badge-light fw-bold">
                                          {merchant.currency}
                                        </div>
                                      </td>
                                      <td>{merchant?.pricingModel ?? "---"}</td>
                                      <td>
                                        {moment(merchant.createdAt)
                                          .tz(process.env.REACT_APP_TIMEZONE)
                                          .format("Do MMM, YYYY")}
                                      </td>
                                      <td>
                                        <span
                                          className={
                                            merchant.status === true
                                              ? "badge text-white bg-success"
                                              : "badge text-white bg-warning"
                                          }
                                        >
                                          {merchant.status === true
                                            ? "Active"
                                            : "Suspended"}
                                        </span>
                                      </td>
                                      <PermissionGate
                                        required={`manage_merchant_credit_card_topup`}
                                        fallback={<></>}
                                        show={false}
                                      >
                                        <td>
                                          <span
                                            className={
                                              merchant.creditCardTopupEnabled === true
                                                ? "badge text-white bg-success"
                                                : "badge text-white bg-secondary"
                                            }
                                          >
                                            {merchant.creditCardTopupEnabled === true ? "Enabled" : "Disabled"}
                                          </span>
                                        </td>
                                      </PermissionGate>
                                      <td className="">
                                        <div className="btn-group">
                                          {/*begin::View*/}
                                          <PermissionGate
                                            required={`view_merchant_details`}
                                            fallback={<></>}
                                          >
                                            <Link
                                              to={`/merchants/merchant-details/${merchant._id}`}
                                              className="btn px-2 btn-outline btn-success btn-color-white btn-sm"
                                              data-bs-toggle="tooltip"
                                              data-bs-placement="top"
                                              title="Show Details"
                                            >
                                              <i className="bi-duotone bi-eye fs-5"></i>
                                            </Link>
                                          </PermissionGate>
                                          {/*end::View*/}

                                          {/*begin::Edit*/}
                                          <PermissionGate
                                            required={`edit_merchant_details`}
                                            fallback={<></>}
                                          >
                                            <Link
                                              to={`/merchants/edit-merchant/${merchant._id}`}
                                              className="btn px-2 btn-outline btn-primary btn-color-white btn-sm"
                                              data-bs-toggle="tooltip"
                                              data-bs-placement="top"
                                              title="Edit"
                                            >
                                              <i className="bi-duotone bi-pen fs-5"></i>
                                            </Link>
                                          </PermissionGate>
                                          {/*end::Edit*/}

                                          {/*begin::Suspend*/}
                                          <PermissionGate
                                            required={
                                              merchant.status === true
                                                ? `suspend_merchant`
                                                : `activate_merchant`
                                            }
                                            fallback={<></>}
                                          >
                                            <span
                                              onClick={() => {
                                                openPopup("change-status", {
                                                  id: merchant._id,
                                                  status: merchant.status,
                                                });
                                              }}
                                              className={
                                                merchant.status === true
                                                  ? "btn px-3 btn-outline btn-warning btn-color-white btn-sm"
                                                  : "btn px-3 btn-outline btn-success btn-color-white btn-sm"
                                              }
                                              data-bs-toggle="tooltip"
                                              data-bs-placement="top"
                                              title={
                                                merchant.status === true
                                                  ? "Suspend Merchant"
                                                  : "Activate Merchant"
                                              }
                                            >
                                              <i
                                                className={
                                                  merchant.status === true
                                                    ? "bi-duotone bi-lock fs-5"
                                                    : "bi-duotone bi-unlock fs-5"
                                                }
                                              ></i>
                                            </span>
                                          </PermissionGate>
                                          {/*end::Suspend*/}

                                          {/*begin::Delete*/}
                                          <PermissionGate
                                            required={`delete_merchant`}
                                            fallback={<></>}
                                          >
                                            <span
                                              onClick={() => {
                                                openPopup("delete", {
                                                  id: merchant._id,
                                                });
                                              }}
                                              className="btn px-3 btn-outline btn-danger btn-color-white btn-sm"
                                              data-bs-toggle="tooltip"
                                              data-bs-placement="top"
                                              title="Delete Merchant"
                                            >
                                              <i className="bi-duotone bi-trash fs-5"></i>
                                            </span>
                                          </PermissionGate>

                                          {/*end::Delete*/}
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      )}

                      {/*end::Table*/}
                      {/*begin::Paginate*/}
                      {count && Math.ceil(count / limit) > 1 ? (
                        <Pagination
                          page={page}
                          setPage={setPage}
                          count={count}
                          limit={limit}
                        />
                      ) : (
                        ""
                      )}
                      {/*end::Paginate*/}
                    </div>
                    {/*end::Card body*/}
                  </div>
                </PermissionGate>

                {/*end::Card*/}
              </div>
              {/*end::Post*/}
            </div>
          </div>
          {/* start :: Change Status */}
          <div
            className={
              popup === "change-status"
                ? "modal fade show d-block"
                : "modal fade"
            }
            tabIndex={-1}
            id="kt_modal_1"
          >
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content text-center bg-warning text-light">
                <div className="modal-header">
                  <h5 className="modal-title mx-auto text-light">
                    CHANGE STATUS
                  </h5>
                </div>
                <div className="modal-body">
                  <p className="h4 text-light">Are You Sure ?</p>
                </div>
                <div className="modal-footer justify-content-center">
                  <button
                    onClick={() => {
                      setMerchant({});
                      setPopup("");
                    }}
                    type="button"
                    className="btn btn-light btn-sm"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-light btn-sm"
                    onClick={changeStatus}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* end :: Change Status */}
          {/* start :: delete */}
          <div
            className={
              popup === "delete" ? "modal fade show d-block" : "modal fade"
            }
            tabIndex={-1}
            id="kt_modal_1"
          >
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content text-center bg-danger text-light">
                <div className="modal-header">
                  <h5 className="modal-title mx-auto text-light">DELETE</h5>
                </div>
                <div className="modal-body">
                  <p className="h4 text-light">Are You Sure ?</p>
                </div>
                <div className="modal-footer justify-content-center">
                  <button
                    onClick={() => {
                      setMerchant({});
                      setPopup("");
                    }}
                    type="button"
                    className="btn btn-light btn-sm"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-light btn-sm"
                    onClick={deleteMerchant}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* end :: delete */}
          {/* start :: Credit Card Topup */}
          <div
            className={
              popup === "credit-card-topup"
                ? "modal fade show d-block"
                : "modal fade"
            }
            tabIndex={-1}
            id="kt_modal_1"
          >
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div
                className={
                  merchant.status === true
                    ? "modal-content text-center bg-success text-light"
                    : "modal-content text-center bg-warning text-light"
                }
              >
                <div className="modal-header">
                  <h5 className="modal-title mx-auto text-light">
                    {merchant.status === true ? "ENABLE" : "DISABLE"} CREDIT CARD TOPUP
                  </h5>
                </div>
                <div className="modal-body">
                  <p className="h4 text-light">
                    {merchant.status === true ? "Enable" : "Disable"} credit card
                    payment for topup for {selectedIds.length} selected merchant
                    {selectedIds.length > 1 ? "s" : ""}?
                  </p>
                </div>
                <div className="modal-footer justify-content-center">
                  <button
                    onClick={() => {
                      setMerchant({});
                      setPopup("");
                    }}
                    type="button"
                    className="btn btn-light btn-sm"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-light btn-sm"
                    onClick={updateCreditCardTopup}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* end :: Credit Card Topup */}
          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default AllMerchants;
